import React, { useEffect, useState } from 'react'
import './Refiller.css';
import { Cookies } from 'react-cookie';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '../Loading';
import axios from 'axios';
import { FaEdit } from 'react-icons/fa';
import { ErrorAlert } from '../middleware/AlertMsg';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
  } from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'

export const AllApprovedRequest = () => {
    const cookies = new Cookies();
    const token = cookies.get('JWTcookie');
    const [requests, setRequest] = useState([])
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    // const baseUrl='https://busy-erin-raven-vest.cyclic.app';
   // const baseUrl = "https://officejeeves.com";
     const baseUrl =  process.env.REACT_APP_BASE_URL;
     const [page, setPage] = useState(0);
     const [rowsPerPage, setRowsPerPage] = useState(25);
     const [searchQuery, setSearchQuery] = useState("");
    let id;
    const [query, setQuery] = useState({
        refillerName: "",
        date: "",
        wareHouseName: "",
        machineName: ""
    });

    const { refillerName, date, wareHouseName, machineName } = query;
    const getRequests = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${baseUrl}/api/allrefillingrequest/?status=Approved&refillerName=${refillerName}&date=${date}&wareHouseName=${wareHouseName}&machineName=${machineName}`,
                { headers: { 'Authorization': 'Bearer ' + token } })
            const data = res.data.data;
            const sortedData=data.sort((a,b)=>{
                return new Date(b.date) - new Date(a.date)
            })
            setRequest(sortedData);
            setLoading(false)
        } catch (error) {
            // console.log(error);
            ErrorAlert({
                title: "Fail",
                message: error.message,
            });
            setLoading(false);
        }
    }


    useEffect(() => {
        id = setTimeout(() => {
            getRequests()
        }, 1000);

        return () => {
            // console.log('id: ', id);
            clearTimeout(id);
        };
    }, [query]);

    const setFormat = (dateString) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleString();
        return formattedDate;
    }

    const handleInputChange = (fieldName, value) => {
        setQuery(prevQuery => ({
            ...prevQuery,
            [fieldName]: value
        }));

    };

    // const handleDelete = (id) => {
    //     // console.log('id: ', id);
    // };

    // console.log("requests", requests)
    // console.log("query", query)
    // table related functions
    useEffect(() => {
        // Reset page to 0 after a search
        setPage(0);
    }, [searchQuery]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredData = requests.filter((item) => {
        return Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
    });
    // end table related functions

    return (
        <div style={{ width: "100%", height: "100vh" }} className='table_container-div'>
            <div >
                <button className="refillerbackbtn" onClick={() => navigate(-1)}>Back</button>
            </div>
            {isLoading ? <Loading /> :
                <div>
                    <div>
                        <h3>All Approved Request's</h3>

                        <div className='filter'>

                            <input
                                type="text"
                                placeholder="Filter By Refiller Name"
                                value={query.refillerName}
                                onChange={e => handleInputChange('refillerName', e.target.value)}
                                variant="outlined"
                                size="small"
                            />
                            <input
                                type="date"
                                value={query.date}
                                onChange={e => handleInputChange('date', e.target.value)}
                                variant="outlined"
                                 size="small"
                            />
                            <input
                                type="text"
                                placeholder="Filter By Warehouse Name"
                                value={query.wareHouseName}
                                onChange={e => handleInputChange('wareHouseName', e.target.value)}
                                variant="outlined"
                                size="small"
                            />
                            <input
                                type="text"
                                placeholder="Filter By Machine Name"
                                value={query.machineName}
                                onChange={e => handleInputChange('machineName', e.target.value)}
                                variant="outlined"
                                size="small"
                            />
                        </div>
                        {requests.length === 0 ?
                            
                            <div style={{
                                width: "90%", display: 'flex', margin: "auto", justifyContent: 'Center', marginTop: "40px",
                                backgroundColor: "black", color: "white", padding: "7px"
                            }}>
                                <p>No Data Found</p>
                            </div>
                            :  <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <StyledTableRow>
                                                <HeaderTableCell>Sr.No</HeaderTableCell>
                                                <HeaderTableCell>Date</HeaderTableCell>
                                                <HeaderTableCell>Request No</HeaderTableCell>
                                                <HeaderTableCell>Refiller Name</HeaderTableCell>
                                                <HeaderTableCell>Machine Name</HeaderTableCell>
                                                <HeaderTableCell>WareHouse</HeaderTableCell>
                                                <HeaderTableCell>Status</HeaderTableCell>
                                                <HeaderTableCell>Actions</HeaderTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                        {
                                            requests?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, i) => (
                                                <StyledTableRow key={item.id} sx={{
                                                    backgroundColor: i % 2 === 0 ? '#f5f5f5' : 'white',
                                                }}>
                                                    <StyledTableCell align="center">{i + 1}</StyledTableCell>
                                                    <StyledTableCell>{setFormat(item.date)}</StyledTableCell>
                                                    <StyledTableCell>{item.refillingRequestNumber}</StyledTableCell>
                                                    <StyledTableCell>{item.refillerName}</StyledTableCell>
                                                    <StyledTableCell>{item.machineName}</StyledTableCell>
                                                    <StyledTableCell>{item.warehouseName}</StyledTableCell>
                                                    <StyledTableCell>
                                                        <div
                                                            style={{ display: 'flex', justifyContent: 'center' }}
                                                        >
                                                            <div
                                                                style={{
                                                                    backgroundColor: item.status === "Pending" ? "red" : "green",
                                                                    padding: '5px',
                                                                    width: '4px',
                                                                    height: "4px",
                                                                    borderRadius: "100%",
                                                                }}
                                                            >
                                                            </div>
                                                        </div>
                                                    </StyledTableCell>
                                                    <StyledTableCell >
                                                        <div className="actionsBtn">
                                                            <Link to={`/refillermanager/managerefillrequest/${item._id}`}>
                                                                <FaEdit />
                                                            </Link>
                                                            {/* <FaTrash
                                                                onClick={() => handleDelete(item._id)}
                                                            /> */}
                                                        </div>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))
                                        }
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        component="div"
                                        count={requests.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                               </TableContainer> 
                            }
                            
                    </div>
                </div>
            }
        </div>
    );
}
